// extracted by mini-css-extract-plugin
export default {"total":"total_price_total__PDer3"};